<template>
  <v-container class="usuarios">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form ref="form">
        <PageTitle
          main="Administração"
          icon="mdi-pencil-box-outline"
          sub="Cadastro de usuários"
          home="/administracao"
        />
        <Cadastro />
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Cadastro from '../cadastros/usuarios'
export default {
  name: 'Usuarios',
  components: { PageTitle, Cadastro },
  data: () => ({

  })
}
</script>
